<template>
  <onboardingModal :step="2">
    <template slot="body">
      <div class="d-flex flex-column align-items-center">
        <p class="text-primary text-center">{{$t('onboarding.select_an_option')}}</p>
        <ul class="d-flex flex-column align-items-stretch website-options mb-5">
          <li
            v-for="option in options"
            @click="goToWebsiteIntegration(option.type)"
            class="my-2 pointer"
          >
            <b-row class="w-100 no-gutters">
              <b-col
                class="bg-secondary p-3 d-flex col-2 align-items-center justify-content-center rounded-left">
                <i class="fa-2x text-white" :class="option.icon"></i>
              </b-col>
              <b-col class="bg-light text-primary p-3 rounded-right website-info border-left-0">
                <h5 class="font-weight-normal mb-0">{{option.title}}</h5>
                <p class="mb-0 small" v-html="option.desc"></p>
              </b-col>
            </b-row>
          </li>
        </ul>
        <router-link :to="{path: '/'}">
          <b-btn variant="link" size="sm">
            <u>{{$t('onboarding.close_modal')}}</u>
          </b-btn>
        </router-link>
      </div>
    </template>
  </onboardingModal>
</template>

<script>
  import onboardingModal from './onboardingModal.vue'
  import i18n from '@/utils/i18n';

  export default {
    name: "setupStep2",
    components: {
      onboardingModal
    },
    data() {
      return {
        options: [
          {
            type: "wordpress",
            title: i18n.t('onboarding.website_options.wordpress'),
            desc: i18n.t('onboarding.website_options.wordpress_desc'),
            icon: 'fab fa-wordpress'
          },
          {
            type: "custom",
            title: i18n.t('onboarding.website_options.else'),
            desc: i18n.t('onboarding.website_options.else_desc'),
            icon: 'fas fa-cogs'
          },
          {
            type: "not_sure",
            title: i18n.t('onboarding.website_options.not_sure'),
            desc: i18n.t('onboarding.website_options.not_sure_desc'),
            icon: 'far fa-question-circle'
          }
        ]
      }
    },
    created() {
      if (!this.$store.getters['auth/user']) {
        this.$router.replace({name: '404'})
      }
    },
    methods: {
      goToWebsiteIntegration(websiteType) {
        if (websiteType !== 'not_sure') {
          this.$router.push({path: `/setup-step3/${websiteType}`, params: {type: websiteType}});
        } else {
          window.open("mailto:help@wallkit.net", "_blank");
        }
      }
    }
  }
</script>

<style>
</style>